import { STAKEHOLDER_TYPE, WEB_ROLE } from "../../../../common/Constant";

export const validateStakeholderContactInfo = (
  userRole: string | number | null,
  salutationTypeId: string | number | null,
  firstName: string,
  emailId: (string | number)[], // <- Move emailAddress here
  phoneNumber: (string | number)[],
  faxNumber: (string | number)[],
  isSpecialStakeholder: boolean, // Added parameter
  specialization: string,
  experienceinyears: string,
  StakeholderLabel: string,
  selectedUserRoleLabel: string
): string[] => {
  const errors: string[] = [];

  const trimmedFirstname = firstName.trim();
  console.log(StakeholderLabel, userRole, "StakeholderLabel");
  console.log(selectedUserRoleLabel, "selectedUserRoleLabel");

  // Validate Salutation
  if (StakeholderLabel === STAKEHOLDER_TYPE.PMC) {
    if (userRole === null || userRole === "") {
      errors.push("User Role is mandatory");
    }
  }
  if (salutationTypeId === null || salutationTypeId === "") {
    errors.push("Salutation is mandatory");
  }
  if (!trimmedFirstname) {
    errors.push("First Name is mandatory");
  }

  if (
    StakeholderLabel === STAKEHOLDER_TYPE.QME_Doctor ||
    selectedUserRoleLabel === WEB_ROLE.QME_Doctor
  ) {
    if (!specialization.trim()) {
      errors.push("Specialization is mandatory.");
    }

    // if (!experienceinyears.trim()) {
    //   errors.push("Experience is mandatory.");
    // }
  }

  // Validate Email
  if (emailId.length === 0) {
    errors.push("Email is mandatory");
  } else {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const emailSet = new Set();
    emailId.forEach((email) => {
      const trimmedEmailAddress = email.toString().trim();

      if (!trimmedEmailAddress) {
        errors.push("Email is mandatory");
      } else if (!emailRegex.test(trimmedEmailAddress)) {
        errors.push(`Invalid Email Address: ${trimmedEmailAddress}`);
      }

      if (emailSet.has(trimmedEmailAddress)) {
        errors.push(`Duplicate Email Address: ${trimmedEmailAddress}`);
      } else {
        emailSet.add(trimmedEmailAddress);
      }
    });
  }

  // Validate Phone Number
  if (phoneNumber.length > 0) {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;

    const phoneSet = new Set();
    phoneNumber.forEach((num) => {
      const trimmedPhoneNumber = num.toString().trim();

      if (!phoneRegex.test(trimmedPhoneNumber)) {
        errors.push(`Invalid Phone Number: ${trimmedPhoneNumber}`);
      }

      if (phoneSet.has(trimmedPhoneNumber)) {
        errors.push(`Duplicate Phone Number: ${trimmedPhoneNumber}`);
      } else {
        phoneSet.add(trimmedPhoneNumber);
      }
    });
  }
  if (faxNumber.length > 0) {
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;

    const faxSet = new Set();
    faxNumber.forEach((num) => {
      const trimmedFaxNumber = num.toString().trim();

      if (!faxRegex.test(trimmedFaxNumber)) {
        errors.push(`Invalid Fax Number: ${trimmedFaxNumber}`);
      }

      if (faxSet.has(trimmedFaxNumber)) {
        errors.push(`Duplicate Fax Number: ${trimmedFaxNumber}`);
      } else {
        faxSet.add(trimmedFaxNumber);
      }
    });
  }

  return errors;
};

export const validateClinicAddress = (
  addressDetails: {
    city: string;
    state: string;
    country: string;
    zip: string;
    medicareId: string;
    providerName: string;
    providerAddress: string;
  },
  isManualEntry: boolean,
  manualAddress: string,
  manualLocation: string,
  manualCity: string,
  manualCountry: string,
  manualState: string,
  manualZip: string,
  clinicemailId: (string | number)[],
  clinicphoneNumber: (string | number)[],

  clinicfaxNumber: (string | number)[]
): string[] => {
  const errors: string[] = [];

  // Validate each address field separately
  if (!isManualEntry && !addressDetails.city.trim()) {
    errors.push("Please select location");
  }

  if (isManualEntry && !manualLocation) {
    errors.push("Please add Manual Location");
  }
  if (isManualEntry && !manualAddress) {
    errors.push("Please add Manual Address Line 1");
  }
  if (isManualEntry && !manualCity) {
    errors.push("Please add Manual City");
  }
  if (isManualEntry && !manualState) {
    errors.push("Please add Manual State");
  }
  if (isManualEntry && !manualCountry) {
    errors.push("Please add Manual Country");
  }
  if (isManualEntry && !manualZip) {
    errors.push("Please add Manual Zip Code");
  }

  if (clinicemailId) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const emailSet = new Set();
    clinicemailId.forEach((email) => {
      const trimmedEmailAddress = email.toString().trim();

      if (!trimmedEmailAddress) {
        errors.push("Email is mandatory");
      } else if (!emailRegex.test(trimmedEmailAddress)) {
        errors.push(`Invalid Email Address: ${trimmedEmailAddress}`);
      }

      if (emailSet.has(trimmedEmailAddress)) {
        errors.push(`Duplicate Email Address: ${trimmedEmailAddress}`);
      } else {
        emailSet.add(trimmedEmailAddress);
      }
    });
  }
  if (clinicphoneNumber.length > 0) {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;

    const phoneSet = new Set();
    clinicphoneNumber.forEach((num) => {
      const trimmedPhoneNumber = num.toString().trim();

      if (!phoneRegex.test(trimmedPhoneNumber)) {
        errors.push(`Invalid Phone Number: ${trimmedPhoneNumber}`);
      }

      if (phoneSet.has(trimmedPhoneNumber)) {
        errors.push(`Duplicate Phone Number: ${trimmedPhoneNumber}`);
      } else {
        phoneSet.add(trimmedPhoneNumber);
      }
    });
  }

  // Validate Email Address (at least one required)

  if (clinicfaxNumber.length > 0) {
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;

    const faxSet = new Set();
    clinicfaxNumber.forEach((num) => {
      const trimmedFaxNumber = num.toString().trim();

      if (!faxRegex.test(trimmedFaxNumber)) {
        errors.push(`Invalid Fax Number: ${trimmedFaxNumber}`);
      }

      if (faxSet.has(trimmedFaxNumber)) {
        errors.push(`Duplicate Fax Number: ${trimmedFaxNumber}`);
      } else {
        faxSet.add(trimmedFaxNumber);
      }
    });
  }
  return errors;
};

export const validateStakeholderHeaders = (
  entityName: string | number | null,
  partyType: string | number | null
): string[] => {
  const errors: string[] = [];

  // Validate Salutation

  if (!entityName) {
    errors.push("Entity Name is mandatory");
  }
  if (partyType === null || !partyType) {
    errors.push("Party Type is mandatory.");
  }

  // Validate Email

  return errors;
};

export const validateStakeholderAddress = (
  addressType: string | number | null,
  addressDetails: { city: string; state: string; country: string; zip: string },
  addressline1: string | number | null,
  phoneNumber: string | null,
  faxNumber: string | null
): string[] => {
  const errors: string[] = [];

  // if (!addressType) {
  //   errors.push("Address Type is mandatory.");
  // }

  if (!addressDetails.city.trim()) {
    errors.push("Please select City, State, Country and ZipCode");
  }

  if (!addressline1) {
    errors.push("Address Line #1 is mandatory");
  }
  if (!phoneNumber) {
    errors.push("Phone number is mandatory.");
  } else if (phoneNumber) {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!phoneRegex.test(phoneNumber)) {
      errors.push("Phone number is invalid.");
    }
  }

  if (faxNumber) {
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!faxRegex.test(faxNumber)) {
      errors.push("Fax number is invalid.");
    }
  }

  return errors;
};

export const validateContactUser = (
  saluation: string | number | null,
  firstName: string,
  userName: string | null,
  gender: string | number | null,
  emailId: string,
  phoneNumber: string | null,
  faxNumber: string | null,
  webRoleID: (any | null)[],
  departmentID: string | number | null,
  userTypeID: string | number | null,
  StakeholderLabel?: string,
  userTypeOptions?: { value: any; label: string }[]
): string[] => {
  const errors: string[] = [];

  const trimmedFirstname = firstName.trim();
  const trimmedEmailAddress = emailId.trim();

  if (saluation === null || saluation === "") {
    errors.push("Please select Salutation");
  }

  if (!trimmedFirstname) {
    errors.push("First Name is mandatory");
  }

  if (!userName) {
    errors.push("Username is mandatory");
  } else if (userName.length < 3) {
    errors.push("Username should be at least 3 characters long");
  }

  // if (gender === null || gender === "") {
  //   errors.push("Please select Gender");
  // }

  if (!trimmedEmailAddress) {
    errors.push("Email is mandatory");
  } else {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(trimmedEmailAddress)) {
      errors.push("Email ID is invalid.");
    }
  }

  if (!phoneNumber) {
    errors.push("Phone number is mandatory.");
  } else {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!phoneRegex.test(phoneNumber)) {
      errors.push("Phone number is invalid.");
    }
  }

  if (faxNumber) {
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!faxRegex.test(faxNumber)) {
      errors.push("Fax number is invalid.");
    }
  }

  if (!webRoleID || webRoleID.length === 0) {
    errors.push("At least one Web Role must be selected.");
  }

  if (departmentID === null) {
    errors.push("Please select Department.");
  }

  if (userTypeID === null) {
    errors.push("Please select User Type.");
  }

  // ✅ Stakeholder-specific UserType label validation
  // if (StakeholderLabel && userTypeOptions && userTypeID !== null) {
  //   const selectedUserType = userTypeOptions.find(
  //     (opt) => opt.value === userTypeID
  //   );

  //   let expectedLabel: string | null = null;

  //   switch (StakeholderLabel) {
  //     case STAKEHOLDER_TYPE.QME_Doctor:
  //       expectedLabel = "External - Independent QME Doctor";
  //       break;
  //     case STAKEHOLDER_TYPE.PMC:
  //       expectedLabel = "External - PMC";
  //       break;
  //     case STAKEHOLDER_TYPE.Défense_Attorney:
  //     case STAKEHOLDER_TYPE.Applicant_Attorney:
  //       expectedLabel = "External - Attorney(s)";
  //       break;
  //     case STAKEHOLDER_TYPE.Employer:
  //       expectedLabel = "External - Employer";
  //       break;
  //     case STAKEHOLDER_TYPE.Insurance:
  //       expectedLabel = "External - Insurance (Claims)";
  //       break;
  //     case STAKEHOLDER_TYPE.Patient:
  //       expectedLabel = "Injured Worker";
  //       break;
  //     case STAKEHOLDER_TYPE.Vendor:
  //       expectedLabel = "Internal - Consultant";
  //       break;
  //     case STAKEHOLDER_TYPE.Vendor:
  //       expectedLabel = "External - Consultant";
  //       break;
  //     case STAKEHOLDER_TYPE.Service_Provider:
  //       expectedLabel = "Employee";
  //       break;
  //   }

  //   if (expectedLabel && selectedUserType?.label !== expectedLabel) {
  //     errors.push(
  //       `For Stakeholder '${StakeholderLabel}', User Type must be '${expectedLabel}'.`
  //     );
  //   }
  // }

  return errors;
};
